import React from 'react';

const Header = ({ 
  menuOpen, 
  setMenuOpen, 
  user, 
  setPage, 
  handleLogout, 
  setShowTour 
}) => {
  return (
    <header style={{ padding: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <button onClick={() => setMenuOpen(!menuOpen)} data-tour="hamburger-menu" style={{ background: 'none', border: 'none', cursor: 'pointer' }}>
          <div style={{ width: '24px', height: '2px', backgroundColor: '#1d2934', marginBottom: '4px' }}></div>
          <div style={{ width: '24px', height: '2px', backgroundColor: '#1d2934', marginBottom: '4px' }}></div>
          <div style={{ width: '24px', height: '2px', backgroundColor: '#1d2934' }}></div>
        </button>
        <img
          src="/logo.svg"
          alt="PatTrak Logo"
          style={{
            height: '32px',
            marginLeft: '32px',
            cursor: 'pointer'
          }}
          onClick={() => setPage('search')}
        />
      </div>

      <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
        {user ? (
          <>
            <span style={{ color: '#5e778a', fontSize: '14px' }}>{user.email} ({user.tier})</span>
            {user.is_admin && (
              <button onClick={() => setPage('admin')} style={{ background: '#545f6b', color: 'white', padding: '6px 12px', borderRadius: '4px', border: 'none', cursor: 'pointer', fontSize: '14px' }}>
                Admin
              </button>
            )}
            <button onClick={handleLogout} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#1d2934' }}>
              Logout
            </button>
          </>
        ) : (
          <>
            <button onClick={() => setPage('login')} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#1d2934' }}>Log in</button>
            <button onClick={() => setPage('register')} style={{ background: '#53dafc', color: 'white', padding: '8px 16px', borderRadius: '4px', border: 'none', cursor: 'pointer' }}>Sign up free</button>
          </>
        )}
        <button
          onClick={() => {
            localStorage.removeItem('tour_completed_main');
            setShowTour(true);
          }}
          data-tour="help-button"
          title="Take a tour"
          style={{
            background: '#f0f4f8',
            border: '2px solid #1976d2',
            borderRadius: '50%',
            width: '32px',
            height: '32px',
            cursor: 'pointer',
            color: '#1976d2',
            fontWeight: 'bold',
            fontSize: '16px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          ?
        </button>
      </div>
    </header>
  );
};

export default Header;
